import { render, staticRenderFns } from "./BetsCard.vue?vue&type=template&id=295205e0"
import script from "./BetsCard.vue?vue&type=script&lang=js"
export * from "./BetsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports